import { Badge, Button, Card, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBox, faFileExport, faTrash } from "@fortawesome/free-solid-svg-icons";
import PageBreadcrumb from "components/common/PageBreadcrumb";
import SearchBox from "components/common/SearchBox";
import AccessDeniedOverlay from "components/modules/common/AccessDeniedOverlay";

const pedidosCompraBreadcrumb = [
  { label: "Compras", url: "/compras" },
  { label: "Pedidos", active: true },
];

const AccessDeniedPedidos = () => {
  return (
    <div>
      <PageBreadcrumb items={pedidosCompraBreadcrumb} />
      <div className="mb-9">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="mb-0">Pedidos</h2>
          <div className="d-flex gap-2">
            <Button
              variant="outline-danger"
              onClick={() => {}}
              className="px-4 py-2"
              disabled={true}
            >
              <FontAwesomeIcon icon={faTrash} className="me-2" />
              Limpar Tudo
            </Button>
            <Button
              disabled={true}
              onClick={() => {}}
              className="px-4 py-2"
            >
              <FontAwesomeIcon icon={faFileExport} className="me-2" />
              Exportar CSV
            </Button>
          </div>
        </div>

        <div className="mb-4 position-relative">
          <SearchBox
            className="w-100"
            placeholder="Buscar produto por código, nome ou descrição"
            onChange={() => {}}
            value=""
            disabled={true}
          />
        </div>

        <AccessDeniedOverlay message="Você não tem permissão para incluir produtos no pedido.">
          <Card
            className="border-0 shadow-sm"
            style={{
              filter: "blur(8px)",
              pointerEvents: "none",
              userSelect: "none",
            }}
          >
            <Card.Header className="border-bottom-0 py-3">
              <Row className="align-items-center">
                <Col>
                  <h5 className="mb-0 text-body-emphasis d-flex align-items-center">
                    <FontAwesomeIcon icon={faBox} className="me-2" />
                    Produtos no Pedido
                  </h5>
                </Col>
                <Col xs="auto">
                  <Badge bg="primary" pill className="fs-9 px-3 py-2">
                    0 itens
                  </Badge>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="text-center py-5">
                <div className="mb-4">
                  <FontAwesomeIcon
                    icon={faBox}
                    size="4x"
                    className="text-body-tertiary opacity-50"
                  />
                </div>
                <h5 className="text-body-secondary mb-2">
                  Nenhum produto adicionado
                </h5>
                <p className="text-body-tertiary mb-0 small">
                  Use o campo de busca acima para adicionar produtos ao
                  pedido
                </p>
              </div>
            </Card.Body>
          </Card>
        </AccessDeniedOverlay>
      </div>
    </div>
  );
};

export default AccessDeniedPedidos;
